import { Row, Col, useToaster, Table, Whisper, IconButton, Popover, Dropdown } from "rsuite"
import MoreIcon from '@rsuite/icons/legacy/More';
import React from "react";

import { startNewEdit } from "../briefs/briefLocalStorageManager";
import { deleteBrief } from "../briefs/briefCreationManager";
import { copyLink } from "../briefs/briefDrawerFooter";

const MenuPopover = React.forwardRef(({ setOpen, onSelect, rowData, updateBriefs, toaster, ...rest }, ref) => (
    <Popover ref={ref} {...rest} full>
      <Dropdown.Menu onSelect={onSelect}>
        <Dropdown.Item eventKey={1} onClick={() => {
            startNewEdit(rowData.id, rowData.key);
            localStorage.setItem('brief:need_fetch', rowData.id);
            setOpen(true);
            onSelect();
        }}>
            Редактировать
        </Dropdown.Item>
        <Dropdown.Item eventKey={1} onClick={() => {
            copyLink(rowData.id, toaster);
            onSelect();
        }}>
            Копировать ссылку
        </Dropdown.Item>
        <Dropdown.Item eventKey={1} onClick={async () => {
            await deleteBrief(rowData.id);
            updateBriefs();
            onSelect();
        }}>
            <span style={{color: "var(--rs-red-500)"}}>Удалить</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  ));

export default function ActionCell ({ open, setOpen, rowData, dataKey, updateBriefs, ...props }) {
    const { Cell } = Table;
    const ref = React.useRef();
    const toaster = useToaster();

    function handleSelectMenu(eventKey, event) {
        console.log(eventKey);
        ref.current.close();
      }

    return (
        <Cell {...props} style={{flexWrap: "nowrap"}}>
        <Whisper placement="autoVerticalEnd" trigger="click" ref={ref}
            speaker={<MenuPopover
              onSelect={handleSelectMenu}
              setOpen={setOpen}
              rowData={rowData}
              updateBriefs={updateBriefs}
              toaster={toaster}
          />}>
            <IconButton appearance="subtle" icon={<MoreIcon />} />
        </Whisper>
        </Cell>
    );
};